module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "kp-modular-panel",
    attrs: {
      "id": "kp-modular-panel"
    }
  }, [_c('menu-buttons'), _vm._v(" "), _c('steps'), _vm._v(" "), _c('types'), _vm._v(" "), _c('view-mode'), _vm._v(" "), _c('themes'), _vm._v(" "), _c('config'), _vm._v(" "), _c('trigger-button'), _vm._v(" "), _c('modifiers'), _vm._v(" "), _c('advanced-config')], 1)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-2c3cd23a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/Main.vue
 ** module id = 787
 ** module chunks = 1
 **/